import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

/**
 * Modal :layout
 * desc: ModalBasicLayout
 */
const BasicLayout = ({ label, contentSet, labelIcon, styleDef, viewStatus, onClickEvt, error }) => {
  const set = '';
  return (
    <div className="_basic_modal_div" style={styleDef}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <div className="_modal_tit_div">
        <div className="_icon">
          <i className={labelIcon} />
          <span className="_tit">{label}</span>
        </div>
        <div className="_close" onClick={onClickEvt}>
          <i className="ri-close-circle-line" style={{color:"#37b7ff"}}/>
        </div>
      </div>

      <div className="_content">{contentSet()}</div>
    </div>
  );
};

BasicLayout.propTypes = {
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  onClickEvt: PropTypes.func,
  contentSet: PropTypes.func,
  error: PropTypes.object,
};
BasicLayout.defaultProps = {
  label: '적용',
  labelIcon: '',
  styleDef: {},
  viewStatus: '',
  onClickEvt: () => {},
  contentSet: () => {},
  error: { error: false, msg: '' },
};

export default BasicLayout;
